<section class="container">
  <section class="heading" data-testid="active-state-title">
    <app-dot-pulse />
    <p class="body bold">Repairer to arrange</p>
  </section>

  <section>
    @if (isTvRemoteReplacement()) {
      <p class="body" data-testid="new-visit-message">
        The repairer will be in touch directly. Your booking details should show 24 hours after they’ve contacted you.
      </p>
    } @else {
      <p class="body" data-testid="new-visit-message">
        The repairer has their own booking system. So, they’ll be in touch directly to arrange your engineer visit.
      </p>
    }
  </section>
</section>
